export enum StaticSourceUrl {
  DataWrapper = "datawrapper.dwcdn.net",
  FacebookSocialPlugin = "www.facebook.com/plugins/post.php",
  SCMPMultimedia = "multimedia.scmp.com",
  YouTube = "www.youtube.com",
}
